module.exports = __webpack_public_path__ + "PERUVIANhome-11.71823d0b.png";